import type { PropsWithChildren } from "react";
import HomeSidebar from "./layout-sidebar.tsx";

export default function HomeLayout({ children }: PropsWithChildren) {
    return <HomeSidebar>{children}</HomeSidebar>;
}
